module.exports = __webpack_public_path__ + "static/monetize-4-afadc9ae4bd7fda8789d47e688761d1b.png";